import { mapObjectize } from 'cityads-v3/utils/apiUtils'

import {
  GET_ZALEYCASH_ACCOUNTS,
  GET_ZALEYCASH_ACCOUNTS_SUCCESS,
  GET_ZALEYCASH_ACCOUNTS_FAIL,

  CREATE_ZALEYCASH_ACCOUNT,
  CREATE_ZALEYCASH_ACCOUNT_SUCCESS,
  CREATE_ZALEYCASH_ACCOUNT_FAIL,

  SET_ZALEYCASH_ACCOUNT_CREATION_ERRORS,

  DELETE_ZALEYCASH_ACCOUNT,
  DELETE_ZALEYCASH_ACCOUNT_SUCCESS,
  DELETE_ZALEYCASH_ACCOUNT_FAIL,

  CLEAN_ZALEYCASH_PAYMENT_PREVIEW,

  GET_ZALEYCASH_PAYMENT_PREVIEW,
  GET_ZALEYCASH_PAYMENT_PREVIEW_SUCCESS,
  GET_ZALEYCASH_PAYMENT_PREVIEW_FAIL,

  CREATE_ZALEYCASH_PAYMENT,
  CREATE_ZALEYCASH_PAYMENT_SUCCESS,
  CREATE_ZALEYCASH_PAYMENT_FAIL,
} from 'cityads-v3/actions/zaleyCash';

const initialState = {
  accountsById: {},
  accountIds: [],
  isLoadingAccounts: false,
  isLoadedAccounts: false,
  loadingErrors: [],

  isSavingAccount: false,
  saveErrors: {},

  isCreatingPayment: false,
  paymentErrors: [],
};

export const PAYMENT_PREVIEW_STATE_EMPTY   = 'EMPTY';
export const PAYMENT_PREVIEW_STATE_PENDING = 'PENDING';
export const PAYMENT_PREVIEW_STATE_READY   = 'READY';
export const PAYMENT_PREVIEW_STATE_ERROR   = 'ERROR';

export default function zaleyCash(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ZALEYCASH_ACCOUNTS:
      return {
        ...state,
        isLoadingAccounts: true,
      };

    case GET_ZALEYCASH_ACCOUNTS_SUCCESS:
      const accounts = action.response.externalAccount.map(item => ({ ...item, id: +item.id }));
      const accountsById = mapObjectize(accounts)

      return {
        ...state,
        accountsById,
        accountIds: accounts.map(item => item.id),
        isLoadingAccounts: false,
        isLoadedAccounts: true,
        loadingErrors: [],
      };

    case GET_ZALEYCASH_ACCOUNTS_FAIL:
      return {
        ...state,
        isLoadingAccounts: false,
        loadingErrors: action.response.errors || (action.response.message && [action.response.message]),
      };

    case CREATE_ZALEYCASH_ACCOUNT:
      return {
        ...state,
        isSavingAccount: true,
        saveErrors: {},
      };

    case CREATE_ZALEYCASH_ACCOUNT_SUCCESS:
      return {
        ...state,
        isSavingAccount: false,
        saveErrors: {},
      };

    case CREATE_ZALEYCASH_ACCOUNT_FAIL:
      return {
        ...state,
        isSavingAccount: false,
        saveErrors: {
          entity: action.response.errors || (action.response.message && [action.response.message])
        },
      };

    case SET_ZALEYCASH_ACCOUNT_CREATION_ERRORS:
      return {
        ...state,
        saveErrors: action.errors,
      };

    case DELETE_ZALEYCASH_ACCOUNT:
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.additional.accountId]: {
            ...state.accountsById[action.additional.accountId],
            isDeleting: true,
            deleteErrors: [],
          }
        },
      };

    case DELETE_ZALEYCASH_ACCOUNT_SUCCESS:
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.additional.accountId]: {
            ...state.accountsById[action.additional.accountId],
            isDeleting: false,
            isDeleted: true,
            deleteErrors: [],
          },
        },
      };

    case DELETE_ZALEYCASH_ACCOUNT_FAIL:
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.additional.accountId]: {
            ...state.accountsById[action.additional.accountId],
            isDeleting: false,
            deleteErrors: action.response.errors || (action.response.message && [action.response.message]),
          },
        },
      };

    case CLEAN_ZALEYCASH_PAYMENT_PREVIEW:
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.accountId]: {
            ...state.accountsById[action.accountId],
            paymentPreview: {
              ...state.accountsById[action.accountId]?.paymentPreview ?? {},
              status: PAYMENT_PREVIEW_STATE_EMPTY,
            },
          }
        },
      };

    case GET_ZALEYCASH_PAYMENT_PREVIEW:
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.additional.accountId]: {
            ...state.accountsById[action.additional.accountId],
            paymentPreview: {
              ...state.accountsById[action.additional.accountId].paymentPreview,
              amountFrom: action.additional.amount,
              status: PAYMENT_PREVIEW_STATE_PENDING,
            },
          }
        },
      };

    case GET_ZALEYCASH_PAYMENT_PREVIEW_SUCCESS:
      if (action.additional.amount !== state.accountsById[action.additional.accountId].paymentPreview.amountFrom) {
        return state;
      }

      if (!action.response.errors && !action.response.message) {
        return {
          ...state,
          accountsById: {
            ...state.accountsById,
            [action.additional.accountId]: {
              ...state.accountsById[action.additional.accountId],
              paymentPreview: {
                ...state.accountsById[action.additional.accountId].paymentPreview,
                amountTo: action.response.amount,
                commission: action.response.commission,
                currency: action.response.currency_code,
                status: PAYMENT_PREVIEW_STATE_READY,
                errors: [],
              },
            },
          },
        };
      }
      // else fall through to next case for error

    case GET_ZALEYCASH_PAYMENT_PREVIEW_FAIL:
      if (action.additional.amount !== state.accountsById[action.additional.accountId].paymentPreview.amountFrom) {
        return state;
      }

      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [action.additional.accountId]: {
            ...state.accountsById[action.additional.accountId],
            paymentPreview: {
              ...state.accountsById[action.additional.accountId].paymentPreview,
              amountTo: null,
              commission: null,
              currency: null,
              status: PAYMENT_PREVIEW_STATE_ERROR,
              errors: action.response.errors || (action.response.message && [action.response.message]),
            },
          },
        },
      };

    case CREATE_ZALEYCASH_PAYMENT:
      return {
        ...state,
        isCreatingPayment: true,
        paymentErrors: [],
      };

    case CREATE_ZALEYCASH_PAYMENT_SUCCESS:
      return {
        ...state,
        isCreatingPayment: false,
        paymentErrors: [],
      };

    case CREATE_ZALEYCASH_PAYMENT_FAIL:
      return {
        ...state,
        isCreatingPayment: false,
        paymentErrors: action.response.errors || (action.response.message && [action.response.message]),
      };

    default:
      return state;
  }
}
